import { useRef } from "react"

export default function useTrigger(value, fieldName, trigger) {
  const currentRef = useRef(value);

  if (currentRef.current !== value) {
    trigger(fieldName);
    currentRef.current = value;
  }
}
